import React, { useState } from "react";

import { useForm } from "react-hook-form";
import { toast } from "react-toastify";

// import JS files
import MuiModal from "../../../shares/MuiModal";
import MuiTextFieldHook from "../../../shares/MuiTextFieldHook";
import useFetch from "../../../../context/useFetch";
import MuiButton from "../../../shares/MuiButton";
import { fixNumbers } from "../../../../utils";

// import Others files

const EmployeeChangePassModal = (props) => {
  const {
    register,
    handleSubmit,
    watch,
    setError,
    control,
    formState: { errors },
    reset,
  } = useForm({
    defaultValues: {},
  });
  const [postData, setPostData] = useState({});
  const EditUserApi = useFetch({
    method: "post",
    url: `User_Service/admin_set_password`,
    trigger: false,
    data: postData,
    caller: props.getFunc,
    argFunc: (res) => {
      // toast.success(" کاربر موردنظر با موفقیت ویرایش شد", {
      //   position: toast.POSITION.TOP_CENTER,
      // });
      props.setOpenModal(false);
    },
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });

  const onSubmit = (data) => {
    if (data["password"] == data["newPassword"]) {
      setPostData({
        user: props.user,
        password: fixNumbers(data["password"]),
      });
      EditUserApi.reFetch();
    } else {
      toast.error("رمز های عبور تطابق ندارند.", {
        position: toast.POSITION.TOP_CENTER,
      });
    }
  };

  return (
    <>
      <MuiModal
        openModal={props.openModal}
        setOpenModal={props.setOpenModal}
        width="w-2/5"
      >
        <form className="" onSubmit={handleSubmit(onSubmit)}>
          <div>
            <div className="flex mb-6 items-center justify-center">
              <span className="show-value font-bold	"> {props.name} </span>
            </div>

            <div className="grid md:grid-cols-2 gap-x-4 mt-1">
              <div className="mt-6">
                <MuiTextFieldHook
                  id="outlined-basic"
                  label="رمز عبور"
                  variant="outlined"
                  size="small"
                  name="password"
                  isLTR={true}
                  control={control}
                  register={{
                    required: {
                      value: true,
                      message: "رمز عبور را وارد کنید",
                    },
                  }}
                />
              </div>
              <div className="mt-6">
                <MuiTextFieldHook
                  id="outlined-basic"
                  label="تکرار رمز عبور"
                  variant="outlined"
                  size="small"
                  name="newPassword"
                  isLTR={true}
                  control={control}
                  register={{
                    required: {
                      value: true,
                      message: "رمز عبور را وارد کنید",
                    },
                  }}
                />
              </div>
            </div>

            <div className="flex justify-end mt-6">
              <MuiButton
                withoutOnClick
                type="submit"
                variant="contained"
                //     icon={<AddIcon />}
                color="success"
                text="ثبت"
              />
            </div>
          </div>
        </form>
      </MuiModal>
    </>
  );
};

export default EmployeeChangePassModal;
